import{enableMapSet as e,produce as t,freeze as n}from"immer";export{immerable,produce}from"immer";import{createPluginCenter as o,request as r,markdown as i}from"@topwrite/core";export{BaseConfig,Book,Config,File,LetterAvatar,Level,Summary,SummaryArticle,SummaryPart,aes,isCancel,isEncryptedData,isRequestError,isUrl,markdown,md5,pluginCenter,request}from"@topwrite/core";import a from"url";import{jsx as c,Fragment as s,jsxs as l}from"react/jsx-runtime";import u,{Suspense as d,Fragment as m,Component as h,useMemo as p,createElement as f,createContext as g,useContext as b,useState as w,useCallback as v,useEffect as x,useRef as y,Children as k,forwardRef as E}from"react";import{useSelector as S,Model as C,createStore as $,Provider as P,useActions as M}from"@topthink/redux-model";export{Model}from"@topthink/redux-model";import z,{createGlobalStyle as L}from"styled-components";export{ThemeProvider,createGlobalStyle,css,keyframes,default as styled}from"styled-components";import{createIntlCache as j,createIntl as D,RawIntlProvider as T}from"react-intl";export{IntlContext,defineMessage,defineMessages,useIntl}from"react-intl";import A from"loadjs";export{default as loadjs}from"loadjs";import I from"query-string";import O from"remark-slug";import{toc as _}from"mdast-util-toc";import{all as N,toHast as V}from"mdast-util-to-hast";import{convert as W}from"unist-util-is";import{toString as F}from"mdast-util-to-string";import{encode as U}from"mdurl";import q from"html-tags";import{debounce as H,throttle as B}from"lodash";export{default as useEvent}from"@react-hook/event";export{useHotkeys}from"react-hotkeys-hook";export{useAsync,useAsyncCallback}from"react-async-hook";export{Helmet}from"react-helmet";e(),window.TopWritePlugins={};class R extends HTMLElement{connectedCallback(){this.addEventListener("click",e=>{if(e.preventDefault(),!this.isContentEditable){const e=this.attributes.getNamedItem("src");let t=e?.value;if(t){let e=document.createElement("a");e.download=this.textContent||"",e.style.display="none",e.target="_blank",e.href=a.resolve(location.href,t),document.body.appendChild(e),e.click(),document.body.removeChild(e)}}})}}function G({component:e,defaultComponent:t=m,props:n,children:o=null,context:r}){return null===e?null:c(d,{fallback:null,children:c(e,{props:n,Component:t,context:r,children:o})})}customElements.define("t-attachment",R);class J extends h{state={hasError:!1};componentDidCatch(){this.setState({hasError:!0})}render(){return this.state.hasError?null:this.props.children}}var K=(e,t)=>e.filter(({descriptor:e})=>t===e.role).sort(({descriptor:{priority:e=0}},{descriptor:{priority:t=0}})=>e-t).map(e=>{return t=e.Component,e=>c(J,{children:c(t,{...e},"WrappedComponent")});var t});function Q({component:e,props:t}){return f(e,t)}function X({props:e,role:t,component:n,context:o}){const r=n?c(Q,{component:n,props:e,context:o}):null,i=S("components");return p(()=>K(i,t),[i,t]).reduce((t,r)=>c(G,{defaultComponent:n,component:r,props:e,context:o,children:t}),r)}function Y({props:e,component:t,role:n,context:o}){const r=S("components"),i=p(()=>K(r,n),[r,n]);return c(s,{children:i.map((n,r)=>c(G,{defaultComponent:t,component:n,props:e,context:o},r))})}const Z="localStorage";function ee(e=Z){if("undefined"==typeof window)throw new Error("Browser storage is not available on NodeJS / TopWrite SSR process");if("none"===e)return null;try{return window[e]}catch(e){return null}}const te={get:()=>null,set:()=>{},del:()=>{}},ne=(e,t)=>{const n=ee(t?.persistence);return n?{get:()=>n.getItem(e),set:t=>n.setItem(e,t),del:()=>n.removeItem(e)}:te};function oe(e=Z){const t=ee(e);if(!t)return[];const n=[];for(let e=0;e<t.length;e+=1){const o=t.key(e);null!==o&&n.push(o)}return n}function re(e,t){if(null===e)return t;if(void 0===t||"string"==typeof t)return e;try{return JSON.parse(e)}catch{return t}}class ie{listeners=new Map;values=new Map;subscribe(e,t){return this.listeners.has(e)||this.listeners.set(e,new Set),this.listeners.get(e).add(t),()=>{const n=this.listeners.get(e);n&&(n.delete(t),0===n.size&&this.listeners.delete(e))}}setValue(e,t,n){this.values.set(e,t);const o=ne(e);t===n?o.del():o.set(function(e){return void 0===e||"string"==typeof e?e:JSON.stringify(e)}(t));const r=this.listeners.get(e);r&&r.forEach(e=>e(t))}getValue(e,t){if(this.values.has(e))return this.values.get(e);const n=re(ne(e).get(),t);return this.values.set(e,n),n}handleStorageEvent(e,t){if(e.key&&this.listeners.has(e.key)){const n=t.get(e.key),o=re(e.newValue,n);this.values.set(e.key,o);const r=this.listeners.get(e.key);r&&r.forEach(e=>e(o))}}}const ae=g(null);function ce({children:e}){const t=p(()=>new ie,[]),n=p(()=>new Map,[]);return x(()=>{const e=e=>{t.handleStorageEvent(e,n)};return window.addEventListener("storage",e),()=>window.removeEventListener("storage",e)},[t,n]),c(ae.Provider,{value:t,children:e})}function se(e,n){const o=b(ae);if(!o)throw new Error("useLocalStorageState must be used within a LocalStorageStateProvider");const[r,i]=w(()=>o.getValue(e,n)),a=v(r=>{if("function"==typeof r){const i=o.getValue(e,n),a=t(i,r);o.setValue(e,a,n)}else o.setValue(e,r,n)},[o,e,n]);return x(()=>o.subscribe(e,i),[o,e]),[r,a]}function le(e,t){let n;return n=t instanceof Array?{Component:t[0],descriptor:{role:e,...t[1]}}:{Component:t,descriptor:{role:e}},n}function ue(){const e=S("book");if(!e)throw new Error("book object not initialized");return e}const de="light",me="dark",he=e=>e===me?me:de,pe=window.matchMedia?window.matchMedia("(prefers-color-scheme: dark)"):void 0,fe=()=>pe?.matches?me:de,ge=g(void 0);function be({children:e,context:t,theme:n}){const o=ue(),[r,i]=se(`${t}.${o.id}.theme`,"auto"),[a,s]=w(()=>{let e;return e=n||"auto"!==r?he(n||r):fe(),e});x(()=>{if(pe&&!n&&"auto"===r){const e=e=>{e.matches?s(me):s(de)};return pe.addEventListener("change",e),()=>{pe.removeEventListener("change",e)}}},[r,n]),x(()=>{s("auto"==r?n||fe():he(r))},[r]),x(()=>{(e=>{document.documentElement.setAttribute("data-theme",e)})(a)},[a]);const l=v(()=>{i(de)},[]),u=v(()=>{i(me)},[]),d=v(()=>{i("auto")},[]),m=v(()=>{"auto"===r?l():a===de?u():d()},[a,r,l,u]);return c(ge.Provider,{value:{theme:a,isAutoTheme:"auto"===r,isDarkTheme:a===me,setLightTheme:l,setDarkTheme:u,setAutoTheme:d,toggleTheme:m},children:e})}function we(){const e=b(ge);if(!e)throw new Error("theme context not exist");return e}const ve=L`
    :root {
        --ttw-color: #333;
        --ttw-primary-color: #3c60ff;
        --ttw-secondary-color: #9e9e9e;
        --ttw-gray-color: rgba(0, 0, 0, 0.5);
        --ttw-background: #fff;
        --ttw-border-color: #eaeaea;
        --ttw-box-color: #212529;
        --ttw-box-background: #FFF;
        --ttw-box-hover-background: #e9ecef;
        --ttw-box-active-background: #f1f2f2;
    }

    [data-theme=dark] {
        --ttw-color: #cacbcf;
        --ttw-secondary-color: #888;
        --ttw-gray-color: rgba(255, 255, 255, 0.5);
        --ttw-background: #1F2428;
        --ttw-border-color: #1B1F23;
        --ttw-box-color: #e1e4e8;
        --ttw-box-background: #2f363d;
        --ttw-box-hover-background: #39414a;
        --ttw-box-active-background: #242A30;
    }
    
    //TODO 转移到异步加载
    //附件
    t-attachment {
        color: var(--ttw-primary-color, #3c60ff);
        display: inline-flex;
        align-items: center;
        cursor: pointer;
        overflow: hidden;
        padding: 0 4px;
        vertical-align: bottom;
        margin: 0 1px;

        &:before {
            content: '';
            width: 18px;
            height: 18px;
            background-color: var(--ttw-primary-color, #3c60ff);
            mask: url("${"data:image/svg+xml,%3csvg t='1642406480574' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='2254' width='16' height='16'%3e %3cpath d='M874.666667 467.2c-10.666667-10.666667-29.866667-12.8-42.666667 0l-343.466667 341.333333c-74.666667 74.666667-198.4 74.666667-275.2 0-36.266667-36.266667-57.6-85.333333-57.6-136.533333s19.2-100.266667 57.6-136.533333L556.8 192c46.933333-46.933333 121.6-46.933333 168.533333 0 23.466667 23.466667 34.133333 53.333333 34.133334 83.2 0 32-12.8 61.866667-34.133334 83.2L384 704c-17.066667 17.066667-44.8 17.066667-64 0-8.533333-8.533333-12.8-19.2-12.8-32s4.266667-23.466667 12.8-32l317.866667-315.733333c10.666667-10.666667 12.8-29.866667 0-42.666667-10.666667-12.8-29.866667-12.8-42.666667 0L277.333333 597.333333c-19.2 19.2-29.866667 46.933333-29.866666 74.666667S258.133333 725.333333 277.333333 746.666667c40.533333 40.533333 106.666667 40.533333 147.2 0L768 403.2c34.133333-34.133333 53.333333-78.933333 53.333333-125.866667s-19.2-93.866667-53.333333-125.866666a178.986667 178.986667 0 0 0-253.866667 0l-341.333333 341.333333c-46.933333 46.933333-74.666667 110.933333-74.666667 179.2s25.6 132.266667 74.666667 179.2c49.066667 49.066667 115.2 74.666667 179.2 74.666667s130.133333-25.6 179.2-74.666667l343.466667-341.333333c10.666667-12.8 10.666667-32 0-42.666667z' p-id='2255'%3e%3c/path%3e%3c/svg%3e"}") no-repeat center;
            margin-right: 4px;
        }

        &:after {
            content: "(" attr(size) ")";
            margin-left: 4px;
            display: none;
        }

        &[size]:after {
            display: inline;
        }

        &:hover {
            background: rgba(0, 0, 0, .1);
        }

        &:read-write {
            cursor: text;
        }
    }
`;const xe=new class extends C{initialState=[];*register(e){yield this.setState(t=>t.push(e))}};const ye=new class extends C{};var ke=Object.freeze({__proto__:null,components:xe,options:ye});const Ee=g(void 0),Se=()=>{const e=b(Ee);if(void 0===e)throw new Error("useIntlContext must be used within a Layout component");return e},Ce=({children:e})=>{const{locale:t,messages:n}=Se(),o=p(()=>{const e=j();return D({locale:t,messages:n,defaultLocale:"en"},e)},[t,n]);return c(T,{value:o,children:e})},$e=({children:e,locale:t,messages:n})=>{const[o,r]=w(n);return c(Ee.Provider,{value:{locale:t,messages:o,setMessages:r},children:c(Ce,{children:e})})};function Pe(e){return e.__esModule&&e.default?e.default:e}class Me{name;book;models={...ke};components=[];activates=[];plugins=[];initialState;constructor(e,t,n){this.name=e,this.book=t,this.initialState=n}registerComponents(e,t){for(let[n,o]of Object.entries(e))o&&("plugin:setting"===n&&(n=`plugin:setting:${t}`),this.components.push(le(n,o)))}registerModels(e,t){for(const[n,o]of Object.entries(e))t?this.models[`@${t}@${n}`]=o:this.models[n]=o}async registerPlugins(e){this.plugins=e;for(const t of e)try{this.registerComponents(t.components,t.name),this.registerModels(t.models,t.name),t.activate&&this.activates.push(t.activate),t.register&&await t.register(this.name,this.book)}catch(e){console.log(e)}}async createApp(e,t=navigator.language,n){t=this.detectLocale(t);const o=await this.loadMessages(t,e),r=$(this.models,{book:this.book,components:this.components,...this.initialState}),i=({children:e})=>c(s,{children:e}),a=({children:e})=>{const t=c(X,{role:`activate:${this.name}`,props:{children:e,name:this.name},component:i});return this.activates.reduce((e,t)=>{const n=t(this.name);return void 0!==n?c(s,{children:n}):e},t)};return({children:e})=>c(P,{store:r,children:c(ce,{children:l(be,{context:this.name,theme:n,children:[c(ve,{}),c($e,{locale:t,messages:o,children:c(a,{children:e})})]})})})}detectLocale(e){const t=ne(`${this.name}.${this.book.id}.lang`);e=t.get()||e;const n=new URLSearchParams(window.location.search).get("lang");return n&&(t.set(n),e=n),document.documentElement.setAttribute("lang",e),e}async loadMessages(e,t){return await this.plugins.reduce(async(t,n)=>{const o=Pe(await t);return n.localize?Object.assign({},o,Pe(await n.localize(e))):o},t(e))}}async function ze(e){let t=`topwrite-plugin-${e.name}`;if(!A.isDefined(t)){let n=`${e.host}/${e.main}`;try{await A(n,t,{returnPromise:!0})}catch{console.warn(`插件${e.name}加载失败`)}}}async function Le(e){const{name:t,book:n,models:i,initialState:a,localize:c,pluginCenter:s,locale:l,theme:u}=e,d=await async function(e,t){let n=[];if(t){const r=o(t);try{n=await r.getInstalled(e),n=n.filter(e=>!window.TopWritePlugins[e.name]?.meta)}catch{}}try{const e=sessionStorage.getItem("PLUGIN_DEV"),t=I.parse(window.location.search);if("dev"in t||e){const o=t.dev||e||8080;try{const e=(await r.get(`http://localhost:${o}/meta`)).data;n=n.filter(t=>t.name!==e.name&&!("theme"===e.type&&"theme"===t.type)),window.TopWritePlugins[e.name]&&delete window.TopWritePlugins[e.name],n.unshift(e),sessionStorage.setItem("PLUGIN_DEV",String(o))}catch(e){console.warn(e),sessionStorage.removeItem("PLUGIN_DEV")}}}catch{}const i=Object.entries(window.TopWritePlugins).filter(([,e])=>!!e.meta).map(([,e])=>e.meta),a=i.some(e=>"theme"===e.type),c=Object.keys(window.TopWritePlugins),s=[];for(let e of n)e.disabled||c.includes(e.name)||a&&"theme"===e.type||s.push(ze(e));return await Promise.all(s),i.push(...n),window.TopWritePluginsMeta=i,Object.values(window.TopWritePlugins||{})}(n,s),m=new Me(t,n,a);return m.registerModels(i),await m.registerPlugins(d),await m.createApp(c,l,u)}function je(e){return M(e)}function De(e){return S(e)}function Te(e){return[De(e),je(e)]}function Ae(e,t,n){const o="function"==typeof t;o||(n=t),x(()=>{let n;const r=e();return Promise.resolve(r).then(e=>{n=e}),()=>{o&&t(n)}},n)}function Ie(e){const t=y(null),[n,o]=w(e);x(()=>{t.current&&(t.current(),t.current=null)},[n]);return[n,(e,n)=>{t.current="function"==typeof n?n:null,o(e)}]}function Oe(){const e=document.currentScript;if(!e)throw new Error("Automatic publicPath is not supported in this browser");return e.src.replace(/#.*$/,"").replace(/\?.*$/,"").replace(/\/[^\/]+$/,"/")}class _e{name;config;localize;models;components;activate;register;meta;constructor({name:e,meta:t,models:n={},components:o={},activate:r,register:i,localize:a,config:c}){this.name=e,this.meta=t,this.models=n,this.components=o,this.activate=r,this.register=i,this.localize=a,this.config=c}}const Ne=g({}),Ve=Ne.Provider;function We(e,t){return b(Ne)[e]||t}const Fe=W("root"),Ue=W("element"),qe=W("text");function He(e){return e.filter(e=>!(qe(e)&&"\n"===e.value))}function Be(e,t,n){const o=t.properties,r=t.tagName,i={...o};n.prefix&&(n.key++,i.key=n.prefix+n.key);const a=[],c=He(t.children),s=c?c.length:0;let l=-1;for(;++l<s;){const t=c[l];Ue(t)?a.push(Be(e,t,n)):qe(t)&&a.push(t.value)}return e.call(t,r,i,a.length>0?a:void 0)}function Re(e,{extensions:t=[],creator:n=u.createElement}){const o={allowDangerousHtml:!1,handlers:{...t.reduce((e,t)=>Object.assign(e,t),{}),textDirective:(e,t)=>e({},"textDirective",{name:t.name,attributes:t.attributes},N(e,t)),leafDirective:(e,t)=>e({},"leafDirective",{name:t.name,attributes:t.attributes},N(e,t)),containerDirective(e,t){"children"in t||(t.children=[]);let n=!1;for(const e of t.children)if(e.data?.directiveLabel){n=!0;break}return n||t.children.unshift({type:"paragraph",children:[{type:"text",value:""}]}),e({},"containerDirective",{name:t.name,attributes:t.attributes},N(e,t))},heading(e,t){const n=e(t,"heading",N(e,t));return n.properties={...n.properties,depth:t.depth},n}},unknownHandler:()=>null},r=V(e,o);if(Fe(r))return He(r.children).map((e,t)=>Ue(e)?Be(n,e,{key:0,prefix:`h-${t}-`}):qe(e)?e.value:void 0);if(!Ue(r))throw new Error("Expected root or element, not `"+(r&&r.type||r)+"`");return Be(n,r,{key:0,prefix:"h-"})}function Ge({extensions:e,tree:t,options:n}){const o=p(()=>{let o=null;if(n){const r=_(t).map;r&&(o=Re(r,{extensions:[...e,{link:(e,t)=>{const n=F(t.children);return e(t,"a",{href:U(t.url)},[{type:"text",value:n}])}}]})),"object"==typeof n&&(o=l(s,{children:[n.header,o,n.footer]}))}return o},[e,t,n]);return o?c("aside",{children:o}):null}const Je=({value:e})=>c("pre",{children:c("code",{children:e})}),Ke=({value:e})=>c("code",{children:e});const Qe=["video","audio","div"];function Xe(e){const{name:t,attributes:n,children:o}=e;let r=We(t),i=`html:${t}`;return customElements.get(`t-${t}`)?r=r||`t-${t}`:Qe.includes(t)||(r=void 0,i=`directive:${t}`),c(X,{role:i,props:{...n,children:o},component:r})}function Ye({depth:e=5,...t}){return f(`h${e}`,t)}const Ze={"x-inline":function(e){const{name:t,value:n}=e;return c(X,{role:`inline:${t}`,props:{type:"inline",name:t,value:n},component:Ke})},"x-block":function(e){const{name:t,value:n,parameter:o}=e;return c(X,{role:`block:${t}`,props:{type:"block",name:t,parameter:o,value:n},component:Je})},textDirective:Xe,leafDirective:Xe,containerDirective:function({name:e,attributes:t,children:n}){let o=We(e),r=`html:${e}`;const[i,...a]=k.toArray(n),s={children:a,label:i,...t};return customElements.get(`t-${e}`)?o=o||`t-${e}`:Qe.includes(e)?s.label=void 0:(o=void 0,r=`directive:${e}`),c(X,{role:r,props:s,component:o})},heading:function(e){const t=We("heading",Ye);return c(X,{role:"html:heading",props:e,component:t})}},et=({tagName:e,inject:t=!0,...n})=>{const o=We(e,e);return t?Ze[e]?f(Ze[e],n):q.includes(e)?c(X,{role:`html:${e}`,props:n,component:o}):(console.warn(`unknown tagName: ${e}`),null):f(o,n)};function tt({tree:e,extensions:t,as:n,css:o,header:r,footer:i,inject:a}){const s=p(()=>Re(e,{extensions:t,creator:(e,t,n)=>f(et,{...t,tagName:e,inject:a},n)}),[e,t]);return l("article",{children:[r,c(nt,{$css:o,as:n,children:s}),i]})}const nt=z.section`
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;
    line-height: 1.2;
    word-wrap: break-word;

    & > *:first-child {
        margin-top: 0 !important;
    }

    & > *:last-child {
        margin-bottom: 0 !important;
    }

    h1, h2, h3, h4, h5, h6, p, ul, ol, blockquote, pre, table, audio, video {
        margin-top: 0;
        margin-bottom: 1em;
        line-height: 1.5;
        padding: 0;

        &:last-child {
            margin-bottom: 0 !important;
        }

        &:first-child {
            margin-top: 0 !important;
        }
    }

    h1, h2, h3, h4, h5, h6 {
        font-weight: 500;
        line-height: 1.2;

        &.align-right {
            text-align: right;
        }

        &.align-center {
            text-align: center;
        }
    }

    h1 {
        font-size: 1.875em;
        margin-top: 1.5em;
        margin-bottom: 1em;
        line-height: 1.3;
    }

    h2 {
        font-size: 1.5em;
        margin-top: 1.5em;
        margin-bottom: 1em;
        line-height: 1.3;
    }

    h3 {
        font-size: 1.25em;
        margin-top: 1.25em;
        margin-bottom: 1em;
        line-height: 1.4;
    }

    h4 {
        font-size: 1.125em;
        margin-top: 1.25em;
        margin-bottom: 1em;
        line-height: 1.4;
    }

    h5 {
        font-size: 1em;
        margin-top: 1em;
        margin-bottom: 1em;
        line-height: 1.4;
    }

    h6 {
        font-size: 0.875em;
        margin-top: 1em;
        margin-bottom: 1em;
        line-height: 1.4;
    }

    hr {
        border: 0;
        border-bottom: 1px solid #eeeeee;
        margin-bottom: 0.5em;
    }

    ul {
        padding-left: 2em;

        ul {
            margin: 0;
        }
    }

    ol {
        padding-left: 2em;
    }

    li {
        line-height: 2;

        &.task-list-item {
            list-style: none;
            position: relative;

            input[type=checkbox] {
                position: absolute;
                left: -1.5em;
                top: 0.5em;
                width: 1em;
                height: 1em;
            }
        }

        &.align-right {
            text-align: right;
        }

        &.align-center {
            text-align: center;
        }
    }

    code {
        display: inline-block;
        border-radius: 4px;
        padding: .2em .4em;
        background-color: #f7f7f7;
        word-break: break-all;
        font-family: Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace;
        white-space: pre;
        line-height: 1.3;
        color: inherit;
        font-size: inherit;
        margin: -.2em .4em;
    }

    pre {
        padding: 1.05em;
        overflow: auto;
        line-height: 1.45;
        background-color: #f7f7f7;
        border: 0;
        border-radius: 3px;
        font-family: Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace;
        font-size: inherit;
    }


    pre > code {
        display: inline;
        max-width: 100%;
        padding: 0;
        margin: 0;
        overflow: initial;
        line-height: inherit;
        background-color: rgba(0, 0, 0, 0);
        border: 0;
        tab-size: 4;
    }

    p {
        &.align-right {
            text-align: right;
        }

        &.align-center {
            text-align: center;
        }
    }

    table {
        border-collapse: collapse;
        table-layout: fixed;
        width: 100%;
        line-height: 1.8;
        border-spacing: 0;

        th {
            text-align: left;

            &[align='center'] {
                text-align: center;
            }

            &[align='right'] {
                text-align: right;
            }
        }

        th, td {
            border: 1px solid #e0e0e0;
            padding: 3px 12px;
            height: 34px;
        }

        tr:hover td {
            background-color: #f1f1f1;
        }
    }

    img {
        max-width: 100%;
        display: inline-block;
        padding: 3px;
        vertical-align: middle;
    }

    a {
        text-decoration: none;
        color: var(--ttw-primary-color, #3c60ff);

        &:hover {
            text-decoration: underline;
        }
    }

    blockquote {
        padding: 5px 5px 5px 15px;
        color: #858585;
        border-left: 4px solid #e5e5e5;

        &.info {
            border-left-color: #5bc0de;
            color: #5bc0de;
            background-color: #f4f8fa;
        }

        &.warning {
            background-color: #fcf8f2;
            border-color: #f0ad4e;
            color: #f0ad4e;
        }

        &.danger {
            color: #d9534f;
            background-color: #fdf7f7;
            border-color: #d9534f;
        }

        &.success {
            background-color: #f3f8f3;
            border-color: #50af51;
            color: #50af51;
        }
    }

    video {
        display: block;
        width: 100%;
    }

    audio {
        display: block;
        width: 100%;
    }

    [data-theme=dark] & {
        code {
            background-color: #333437;
        }

        pre {
            background-color: #333437;
        }

        h1, h2, hr {
            border-color: #404040;
        }

        th, td {
            border-color: #404040;
        }

        tr:hover td {
            background-color: #333437;
        }

        blockquote {
            border-left-color: #858585;

            &.info {
                border-left-color: rgb(27, 110, 134);
                color: rgb(98, 195, 223);
                background-color: rgb(19, 34, 42);
            }

            &.warning {
                background-color: rgb(49, 34, 11);
                border-color: rgb(147, 91, 12);
                color: rgb(241, 176, 84);
            }

            &.danger {
                color: rgb(219, 94, 90);
                background-color: rgb(46, 11, 11);
                border-color: rgb(137, 33, 30);
            }

            &.success {
                background-color: rgb(27, 39, 23);
                border-color: rgb(56, 122, 57);
                color: rgb(98, 183, 98);
            }
        }
    }

    ${e=>e.$css}
`,ot=E(({class:e,...t},n)=>c("div",{ref:n,className:e,...t}));function rt({as:e=m,children:t,components:n={},aside:o=!0,header:r,footer:a,css:s,sectionAs:u,inject:d=!0,loader:h=null,onShow:g,...b}){const v=p(()=>i().use(O).freeze(),[]),[y,k]=w(h),[E,S]=w(null);return Ae(async()=>{try{const e=await v.run(v.parse(t));S(e)}catch(e){console.warn(e),S(!1)}},[t,v]),x(()=>{if(null!==E){if(!1===E)k(null);else if(E){const e=v.data("toHastExtensions");k(l(Ve,{value:{div:ot,...n},children:[c(tt,{tree:E,extensions:e,header:r,footer:a,as:u,css:s,inject:d}),c(Ge,{tree:E,extensions:e,options:o})]}))}g&&requestAnimationFrame(g)}},[E,o,r,a,s,u,d]),f(e,b,y)}function it({onChange:e,onCompositionStart:t,onCompositionEnd:n,...o}){const r=y(!1),i=v(t=>{r.current||e?.(t)},[e]),a=v(e=>{r.current=!0,t?.(e)},[t]),s=v(t=>{r.current=!1,e?.(t),n?.(t)},[n,e]);return c("input",{...o,onChange:i,onCompositionStart:a,onCompositionEnd:s})}function at(e){const t=y();return x(()=>{t.current=e},[e]),t.current}function ct(){const{config:e}=ue();return e.getValue("themeConfig")}function st(e){const t=y(e);x(()=>(document.title=e,()=>{document.title=t.current}),[e])}function lt(e,t,n){const o=y(e),r=y(H(e,t,n));return x(()=>{o.current=e}),x(()=>{r.current=H((...e)=>{o.current(...e)},t,n)},[t,n]),r.current}function ut(e,t,n){const o=y(e),r=y(B(e,t,n));return x(()=>{o.current=e}),x(()=>{r.current=B((...e)=>{o.current(...e)},t,n)},[t,n]),r.current}function dt(){return S("options")}function mt(e){const[o,r]=w(()=>n("function"==typeof e?e():e,!0));return[o,v(e=>{r("function"==typeof e?t(e):n(e))},[])]}const ht=new EventTarget;function pt(){return ht}function ft(e=window.document){if("string"==typeof e){e=(new DOMParser).parseFromString(e,"text/html")}const t=e.querySelector('script[type="application/payload+json"]');if(t)try{return JSON.parse(t.innerHTML)}catch{return{}}}var gt=Object.freeze({__proto__:null,encode:function(e,t=!1){if(null===e)return"";try{return window.btoa(unescape(encodeURIComponent(e)))}catch(e){if(t)throw e;return""}},decode:function(e,t=!1){if(null===e)return"";try{return decodeURIComponent(escape(window.atob(e)))}catch(e){if(t)throw e;return""}}});function bt(){return"undefined"!=typeof window&&/Mac|iPod|iPhone|iPad/.test(window.navigator.platform)}export{it as CompositionInput,X as InjectedComponent,Y as InjectedComponentSet,rt as Markdown,_e as Plugin,gt as base64,Le as createApplication,le as createComponentDescriptor,ne as createStorageSlot,ft as getPayload,Oe as getPublicPath,bt as isMac,oe as listStorageKeys,je as useActions,Ae as useAsyncEffect,ue as useBook,lt as useDebounce,st as useDocumentTitle,pt as useEventTarget,mt as useImmer,Se as useIntlContext,se as useLocalStorageState,Te as useModel,dt as useOptions,at as usePrevious,De as useSelector,Ie as useStateWithCallback,ct as useThemeConfig,we as useThemeContext,ut as useThrottle};
//# sourceMappingURL=index.js.map
